<ng-container *transloco="let t">
  <div style="display: flex; gap: 16px; flex-wrap: wrap; margin-bottom: 16px">
    @for (legend of legends; track legend) {
      <div style="display: flex; align-items: center; gap: 8px; flex: 0 0 auto">
        <div
          style="width: 16px; height: 16px; background-color: {{
            legend.color
          }};"
        ></div>
        <p style="white-space: nowrap; margin: 0">{{ t(legend.name) }}</p>
      </div>
    }
  </div>

  <form [formGroup]="form" style="display: flex; gap: 24px">
    <div
      style="width: 280px; display: flex; flex-direction: column; z-index: 999"
    >
      <mat-radio-group
        formControlName="animalType"
        aria-label="Select an option"
      >
        <mat-radio-button value="cat">{{ t('Cat') }}</mat-radio-button>
        <mat-radio-button value="dog">{{ t('Dog') }}</mat-radio-button>
      </mat-radio-group>

      <div class="mt-4">
        @if (form.get('animalType')?.value === 'cat') {
          <anihis-dental-image-cat (stateReport)="onStateReport($event)" />
        } @else if (form.get('animalType')?.value === 'dog') {
          <anihis-dental-image-dog (stateReport)="onStateReport($event)" />
        }
      </div>
    </div>
    <div>
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
        <!-- Column Definitions -->
        <ng-container matColumnDef="Kvadrant">
          <th mat-header-cell *matHeaderCellDef [matTooltip]="t('Kvadrant')" matTooltipShowDelay="400">{{ t('Kvadrant') }}</th>
          <td mat-cell *matCellDef="let element">{{ element.kvadrant }}</td>
        </ng-container>

        <ng-container matColumnDef="GD">
          <th mat-header-cell *matHeaderCellDef>GD</th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field appearance="outline" class="full-width">
              <input appAutofocus
                matInput
                [formControlName]="element.gdControl"
                [placeholder]="t('Enter value')"
              />
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="GL">
          <th mat-header-cell *matHeaderCellDef>GL</th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field appearance="outline" class="full-width">
              <input
                matInput
                [formControlName]="element.glControl"
                [placeholder]="t('Enter value')"
              />
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="DD">
          <th mat-header-cell *matHeaderCellDef>DD</th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field appearance="outline" class="full-width">
              <input
                matInput
                [formControlName]="element.ddControl"
                [placeholder]="t('Enter value')"
              />
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="DL">
          <th mat-header-cell *matHeaderCellDef>DL</th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field appearance="outline" class="full-width">
              <input
                matInput
                [formControlName]="element.dlControl"
                [placeholder]="t('Enter value')"
              />
            </mat-form-field>
          </td>
        </ng-container>

        <!-- Header Row -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <!-- Data Rows -->
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <div class="row gap-m margin-top-m">
        <mat-form-field
          appearance="outline"
          class="example-full-width input-border"
          style="width: 100%"
        >
          <mat-label>{{ t('Treatment, information, comments') }}</mat-label>
          <textarea matInput formControlName="comments" [rows]="4"> </textarea>
        </mat-form-field>
      </div>
    </div>
  </form>
</ng-container>
